// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3Y0PZ","dragIcon":"Choice_dragIcon__1T2ZU","left":"Choice_left__36Hlg","input":"Choice_input__21Hrw"};